import { TELEMEDICINE_BASE_PATH } from "../../records/constants"

export const StatsEndpoint = {
    STATS: `${TELEMEDICINE_BASE_PATH}/doctor/{id}/stats`,
    AVAILABLE_RECORDS: `${TELEMEDICINE_BASE_PATH}/doctor/{id}/open`,
    RECORD_IN_PROGRESS: `${TELEMEDICINE_BASE_PATH}/doctor/in-progress`
};
